import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/3aa6b5bc-11d7-471b-991f-3d457617b286";
export const REGISTER_URL = "https://a.ntrk2.com/72b04e9c-1f7f-4365-9a52-e988a4f572c3";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gopkwin.loadprkw2a.com/download?openExternalBrowser=1&id=nqkgzn6ie9y81l3";

export * from "./codes";
export * from "./context";
